// extracted by mini-css-extract-plugin
export default {"cyberfox":"CyberFox_cyberfox__sex0j","fox":"CyberFox_fox__tanJH","white":"CyberFox_white__oRrrs","grass":"CyberFox_grass__9CDNz","lapk":"CyberFox_lapk__uYp54"};